'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purchaseClassBundle = exports.classBundlesByMsa = undefined;

var _sagaTools = require('@classpass/saga-tools');

var classBundlesByMsa = exports.classBundlesByMsa = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CLASS_BUNDLES', function (client, msaId) {
  return client.classBundles.getByMsa(msaId);
}, { defaultKey: 1 });

var purchaseClassBundle = exports.purchaseClassBundle = (0, _sagaTools.makeEntityScaffold)('SAGA.API.PURCHASE_CLASS_BUNDLE', function (client, userId, bundleId) {
  return client.classBundles.purchaseBundle(userId, {
    versioned_bundle_id: bundleId
  });
});